import { VERSION } from "./lib/utils/version.js";
import { parseWKB } from "./lib/parse-wkb.js";
import { isWKB } from "./lib/parse-wkb-header.js";
export const WKBWorkerLoader = {
  name: 'WKB',
  id: 'wkb',
  module: 'wkt',
  version: VERSION,
  worker: true,
  category: 'geometry',
  extensions: ['wkb'],
  mimeTypes: [],
  tests: [isWKB],
  options: {
    wkb: {
      shape: 'binary-geometry'
    }
  }
};
export const WKBLoader = {
  ...WKBWorkerLoader,
  parse: async arrayBuffer => parseWKB(arrayBuffer),
  parseSync: parseWKB
};
//# sourceMappingURL=wkb-loader.js.map